import { createPutEndpoint } from '@sonar-software/sonar-http';

export type PutInitiativesLinkJiraRequest = {
	customerId: number;
	initiativeId: number;
	issueKey: string;
	issueName: string;
	projectKey: string;
	statusId: string;
};

export const putInitiativesLinkJira = createPutEndpoint<PutInitiativesLinkJiraRequest>(
	({ initiativeId }) => `/api/v3/initiatives/${initiativeId}/link-jira`,
	{
		requestTransform: ({ initiativeId, ...rest }) => rest
	}
);
